import { render, staticRenderFns } from "./GiftCodeDetailModal.vue?vue&type=template&id=4c950e56&scoped=true&"
import script from "./GiftCodeDetailModal.vue?vue&type=script&lang=js&"
export * from "./GiftCodeDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeDetailModal.vue?vue&type=style&index=0&id=4c950e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c950e56",
  null
  
)

export default component.exports